<!-- 汇率查询 -->
<template>
  <div class="interestBankList">
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :edit-rules="rules"
        :max-height="$store.state.app.tableHeight"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>

<script>
  import { addRules } from './rules.js'; // 校验规则
  import API from '@/api/capitalCenter/moneyDraw';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiUpload from '@/components/SiruiUpload';
  import { mapState } from 'vuex';
  // import InputNumber from '@/components/form-item/input-number';
  export default {
    name: 'interestBankList',
    components: {
      SiruiSearch,
      SiruiUpload,
      // InputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      searchColumns() {
        return [
          {
            // 公司
            name: this.$t('interestBank.column.company'),
            prop: 'companyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
            clearable: true,
            filterable: true,
          },
          {
            // 合同号
            name: this.$t('interestBank.column.contractNo'),
            prop: 'contractNo',
            type: 'input',
          },
          {
            // 借款日期从
            name: this.$t('interestBank.search.loanDateStart'),
            prop: 'loanDateStart',
            type: 'startDaterangePicker',
          },
          {
            // 借款日期到
            name: this.$t('interestBank.search.loanDateEnd'),
            prop: 'loanDateEnd',
            type: 'endDaterangePicker',
          },
          {
            // 还款日期从
            name: this.$t('interestBank.search.refundDateStart'),
            prop: 'refundDateStart',
            type: 'startDaterangePicker',
          },
          {
            // 还款日期到
            name: this.$t('interestBank.search.refundDateEnd'),
            prop: 'refundDateEnd',
            type: 'endDaterangePicker',
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 公司
            field: 'companyCode',
            title: this.$t('interestBank.column.company'),
            width: '180',
            editRender: {
              name: 'ElSelect',
              options: this.companyList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.companyChange },
            },
          },
          {
            // 合同号
            field: 'contractNo',
            title: this.$t('interestBank.column.contractNo'),
            width: '180',
            editRender: {
              name: 'ElInput',
            },
          },
          {
            // 借款日期
            field: 'loanDate',
            title: this.$t('interestBank.column.loanDate'),
            width: '180',
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 借款金额
            field: 'loanAmount',
            title: this.$t('interestBank.column.loanAmount'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.loanAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.loanAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'loanAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 还款日期
            field: 'refundDate',
            title: this.$t('interestBank.column.refundDate'),
            width: '180',
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 还款金额
            field: 'refundAmount',
            title: this.$t('interestBank.column.refundAmount'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.refundAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.refundAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'refundAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 天数
            field: 'loanDays',
            title: this.$t('interestBank.column.loanDays'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.loanDays}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.loanDays}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'loanDays')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 利率
            field: 'interestRate',
            title: this.$t('interestBank.column.interestRate'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestRate}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'interestRate')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 利息
            field: 'interestAmount',
            title: this.$t('interestBank.column.interestAmount'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'interestAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 币种
            field: 'currencyCode',
            title: this.$t('interestBank.column.currencyCode'),
            width: '150',
            editRender: {
              name: 'ElSelect',
              options: this.currencyList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            // 对应银行
            field: 'bankName',
            title: this.$t('interestBank.column.bankName'),
            width: '180',
            editRender: {
              name: 'ElSelect',
              options: this.bankList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            // 备注
            field: 'remark',
            title: this.$t('interestBank.column.remark'),
            width: '200',
            editRender: {
              name: 'ElInput',
            },
          },
        ];
      },
    },
    data() {
      return {
        companyList: [],
        currencyList: [],
        bankList: [],
        action: API.IMPORT_INTERESTBANK,
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
        multipleSelection: [],
        searchForm: {
          companyCode: null,
          contractNo: null,
          loanDateStart: null,
          loanDateEnd: null,
          refundDateStart: null,
          refundDateEnd: null,
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        rules: addRules,
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.getCompany();
      this.getCurrency();
      this.getBankList();
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      //币别
      async getCurrency() {
        let res = await this.$baseRequest.getCurrency();
        if (res) {
          this.currencyList = res;
          this.currencyList = this.currencyList.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      // 获取银行
      async getBankList() {
        let res = await this.$baseRequest.getMDBank();
        if (res) {
          this.bankList = res;
          this.bankList = this.bankList.map((item) => {
            return {
              value: item.bankCode,
              label: item.bankName,
            };
          });
        }
      },
      companyChange(val) {
        val.row.companyName = this.companyList.find(
          (item) => item.value == val.row.companyCode
        ).label;
      },
      async getData() {
        this.load = true;
        const [pageNum, pageSize] = [this.page.pageNum, this.page.pageSize];
        const params = { ...this.searchForm, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_INTERESTBANK_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          }
        }
      },
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'edit') {
          this.handleEdit();
        } else if (value === 'save') {
          this.handleSave();
        } else if (value == 'import') {
          this.$refs.SiruiUpload.dialogUpload = true;
        } else if (value == 'del') {
          this.handleDel();
        }
      },
      // 跳转至新增页面
      handleAdd() {
        let path = {
          path: '/moneyDraw/interestBankAdd',
          name: 'interestBankAdd',
          meta: {
            keepAlive: true,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 编辑
      handleEdit() {
        let selectRecords = this.$refs.table.getCheckboxRecords();
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            this.$refs.table.setActiveRow(item);
          });
          this.$refs.table.validate(selectRecords).catch((errMap) => errMap); //修改校验
        } else {
          this.tips('select', 'error');
        }
      },
      async handleSave() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API.SAVE_INTERESTBANK, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.resetBtnClick();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            this.del(ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        const params = {
          ids,
        };
        this.$axios.post(API.DELETE_INTERESTBANK, params).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate((valid) => {
            if (valid) {
              tableData.map((item) => {
                item.isEnabled = item.isEnabled ? '1' : '0';
              });
              let param = {
                list: tableData,
              };
              resolve(param);
            }
          });
        });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`interestBank.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
